import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * GunlukHatirlaticiPopup
 * Tip bazında gruplanmış, tarih/saat etiketli günlük özet popup.
 */
export default function GunlukHatirlaticiPopup({ acik, kapat, maddeler = [], onItemClick }) {
  const { t } = useLanguage();

  // App katmanındaki kontrole ek güvenlik: içeriksiz modal hiçbir koşulda render edilmez.
  if (!acik || !Array.isArray(maddeler) || maddeler.length === 0) return null;

  const tipConfig = {
    task:        { ikon: "✅", renk: "#6366f1", bg: "rgba(99,102,241,0.18)",  baslikKey: "daily.popup.task"        },
    event:       { ikon: "📅", renk: "#0ea5e9", bg: "rgba(14,165,233,0.18)",  baslikKey: "daily.popup.event"       },
    medicine:    { ikon: "💊", renk: "#10b981", bg: "rgba(16,185,129,0.18)",  baslikKey: "daily.popup.medicine"    },
    appointment: { ikon: "🏥", renk: "#f59e0b", bg: "rgba(245,158,11,0.18)",  baslikKey: "daily.popup.appointment" },
    birthday:    { ikon: "🎂", renk: "#f472b6", bg: "rgba(244,114,182,0.18)", baslikKey: "daily.popup.birthday"    },
  };

  // Tipleri belirlediğimiz sıraya göre grupla
  const tipSirasi = ["task", "appointment", "medicine", "event", "birthday"];
  const gruplar = tipSirasi
    .map((tip) => ({ tip, maddeler: maddeler.filter((m) => m.tip === tip) }))
    .filter((g) => g.maddeler.length > 0);

  const toplamSayi = maddeler.length;

  return (
    <div className="modalOverlay" onClick={kapat}>
      <div className="darkModal hatirlaticiModal" onClick={(e) => e.stopPropagation()}>

        {/* Başlık */}
        <div className="darkModalHeader">
          <div className="hatirlaticiBaslik" style={{ marginBottom: 0, paddingBottom: 0, border: "none" }}>
            <div className="hatirlaticiIkonWrap">🔔</div>
            <div>
              <div className="hatirlaticiTitle">{t("daily.popup.title")}</div>
              <div className="hatirlaticiAlt">
                {toplamSayi > 0
                  ? `${toplamSayi} hatırlatma`
                  : t("daily.popup.noItems")}
              </div>
            </div>
          </div>
          <button className="darkModalClose" onClick={kapat}>×</button>
        </div>

        {/* Gruplu liste */}
        {gruplar.map(({ tip, maddeler: grupMaddeleri }) => {
          const cfg = tipConfig[tip] || tipConfig.task;
          return (
            <div key={tip} style={{ marginTop: 14 }}>
              {/* Grup başlığı */}
              <div style={{
                display: "flex", alignItems: "center", gap: 7,
                marginBottom: 6, paddingLeft: 2,
              }}>
                <span style={{
                  fontSize: 11, fontWeight: 800, letterSpacing: "0.04em",
                  textTransform: "uppercase", color: cfg.renk, opacity: 0.9,
                }}>
                  {cfg.ikon} {t(cfg.baslikKey)}
                </span>
                <div style={{ flex: 1, height: 1, background: cfg.renk, opacity: 0.18 }} />
              </div>

              {/* Grup satırları */}
              <div className="hatirlaticiListe" style={{ marginBottom: 0, maxHeight: "none" }}>
                {grupMaddeleri.map((madde) => (
                  <div
                    key={madde.id}
                    className="hatirlaticiSatir"
                    style={{
                      cursor: madde.sayfa ? "pointer" : "default",
                      borderColor: madde.gecikmisMi ? "rgba(239,68,68,0.25)" : undefined,
                      background: madde.gecikmisMi ? "rgba(239,68,68,0.06)" : undefined,
                    }}
                    onClick={() => { if (madde.sayfa) { onItemClick?.(madde); kapat(); } }}
                  >
                    {/* İkon */}
                    <div className="hatirlaticiSatirIkon" style={{ background: cfg.bg }}>
                      {madde.gecikmisMi ? "🔴" : cfg.ikon}
                    </div>

                    {/* Bilgi */}
                    <div className="hatirlaticiSatirBilgi">
                      <div className="hatirlaticiGorevAd">{madde.baslik}</div>
                      {madde.altBilgi ? (
                        <div className="hatirlaticiAtanan" style={{ color: "var(--text-muted)" }}>
                          👤 {madde.altBilgi}
                        </div>
                      ) : null}
                    </div>

                    {/* Tarih etiketi */}
                    <div
                      className="hatirlaticiGun"
                      style={{ color: madde.gecikmisMi ? "#f87171" : cfg.renk }}
                    >
                      {madde.zaman}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {/* Kapat butonu */}
        <button
          style={{
            marginTop: 16, width: "100%", padding: "11px",
            background: "rgba(99,102,241,0.15)",
            border: "1px solid rgba(99,102,241,0.35)",
            borderRadius: "var(--r-md)", color: "#a5b4fc",
            fontWeight: 700, fontSize: 14, cursor: "pointer",
            transition: "background var(--t-fast)",
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = "rgba(99,102,241,0.25)"}
          onMouseLeave={(e) => e.currentTarget.style.background = "rgba(99,102,241,0.15)"}
          onClick={kapat}
        >
          {t("daily.popup.close")}
        </button>
      </div>
    </div>
  );
}
